<div class="w-full h-full">
  <rk-statistics-dashboard></rk-statistics-dashboard>
</div>
